// Ré-exporte tous les modules API
export { authApi } from './auth';
export { sitesApi } from './sites';
export { healthApi } from './health';
export { systemApi } from './system';
export { settingsApi } from './settings';
export { client, setTokens, clearTokens } from './client';

// API combinée pour compatibilité ascendante
import { authApi } from './auth';
import { sitesApi } from './sites';
import { healthApi } from './health';
import { systemApi } from './system';
import { settingsApi } from './settings';

export const api = {
  // Auth
  loginWithCallback: authApi.loginWithCallback,
  getMe: authApi.getMe,
  logout: authApi.logout,
  isAuthenticated: authApi.isAuthenticated,

  // Sites
  getSites: sitesApi.getSites,
  getSite: sitesApi.getSite,
  createSite: sitesApi.createSite,
  updateSite: sitesApi.updateSite,
  deleteSite: sitesApi.deleteSite,
  checkSite: sitesApi.checkSite,
  toggleFavorite: sitesApi.toggleFavorite,
  getQuickAccessSites: sitesApi.getQuickAccessSites,
  updateQuickAccessOrder: sitesApi.updateQuickAccessOrder,
  getCategories: sitesApi.getCategories,
  logAccess: sitesApi.logAccess,
  getAccessLogs: sitesApi.getAccessLogs,
  generateShareToken: sitesApi.generateShareToken,
  removeShareToken: sitesApi.removeShareToken,

  // Health
  getHealthSummary: healthApi.getHealthSummary,
  getHealth: healthApi.getHealth,
  getPublicSite: healthApi.getPublicSite,

  // System
  getSystemMetrics: systemApi.getMetrics,

  // Settings
  getSystemStatus: settingsApi.getSystemStatus,
  getSettings: settingsApi.getSettings,
  updateSetting: settingsApi.updateSetting,
  toggleRegistration: settingsApi.toggleRegistration,
};

export default api;
